export default __webpack_public_path__ + "static/media/WhiteChristmas.5db9e3d2.mp3";